import PropTypes from 'prop-types';
import React, { Component } from 'react';
import SignaturePad from 'react-signature-pad';
import { Button, Col, Container, Row } from "reactstrap";
import "../../../assets/css/react-signature-pad.css";


class SignatureInput extends Component {
    componentDidMount() {
        let signature = this.refs.signature;
        signature._resizeCanvas();
    }

    clearCanvas = () => {
        let signature = this.refs.signature;
        signature.clear();
        this.props.onClear && this.props.onClear();
    };

    saveToSVG = () => {
        let signature = this.refs.signature;
        this.props.onSave(signature.toDataURL('image/svg+xml'));
    };

    render() {
        return (
            <div className="m-signature-pad-container">
                <Container fluid>
                    <Row className="mb-2">
                        <Col>
                            <SignaturePad ref="signature"/>
                        </Col>
                    </Row>
                    <br />
                    <Row className="justify-content-between">
                        <Col md={{size: 4}}>
                            <Button color="info" outline block onClick={this.clearCanvas}>Clear</Button>
                        </Col>
                        <Col md={{size: 4}}>
                            <Button color="success" className="float-right" block onClick={this.saveToSVG}>Save</Button>
                        </Col>
                    </Row>

                </Container>
            </div>
        );
    }
}

SignatureInput.propTypes = {
    onClear: PropTypes.func,
    onSave: PropTypes.func.isRequired,
};

export default SignatureInput;



// WEBPACK FOOTER //
// ./src/components/controls/inputs/SignatureInput.js